export const truncateHtml = (html: string, length: number) => html;
export const truncate = (text: string, count: number) => text;
export const setExtension = (name: string, ext: string) => {
  const pos = name.lastIndexOf('.');
  return name.substring(0, pos < 0 ? name.length : pos) + `.${ext}`;
};

export const truncateString = (text: string, length: number, separator = ' ', withDots = true) => {
  if (text.length <= length) {
    return text;
  }
  const subString = text.slice(0, length - 1);
  return `${subString.slice(0, subString.lastIndexOf(separator))}${String(withDots ? ' ...' : '')}`;
};
